import { getInitials, onlyNumbers } from 'utils'
import Avatar from 'common/Avatar/Avatar'
import Styles from './Comment.module.scss'

export interface UserAvatarUser {
  type: string
  display_name: string | null
  avatar: string | null
  uuid?: string
  initials: string | null
}

export const UserAvatar = ({ user, size }: { user: UserAvatarUser; size: number }) => {
  const seed = user.uuid ? onlyNumbers(user.uuid) : 1
  return (
    <div className={Styles.avatarWrapper}>
      {user.type === 'User' && (
        <Avatar url={user.avatar} label={getInitials(user.display_name)} size={size} backgroundColor="var(--dark-40)" />
      )}
      {user.type === 'AnonymousUser' && <Avatar seed={seed} size={size} />}
    </div>
  )
}
